import getCustomerHash from '@/js/desktop/components/account/service/getCustomerHash';
import getMainMetaData from '@/js/common/Domain/Service/tracking/getMainMetaData';

export default async (options) => ({
    ...getMainMetaData(options),
    customer_hash: await getCustomerHash(),
});